import LocalStorageHelper from './LocalStorageHelper';

/** «Все портфели» — аналог «Валюта актива» для валюты. */
export const ALL_PORTFOLIOS_OPTION = { id: null, name: 'Все' };

const normalizeStoredPortfolio = (parsed, { allowAll, clientId, userTabs }) => {
  if (parsed == null || typeof parsed !== 'object') {
    return null;
  }

  const ownTab = userTabs.find((tab) => Number(tab.id) === Number(clientId)) ?? userTabs[0] ?? null;
  const defaultOption =
    allowAll && userTabs.length > 1
      ? ALL_PORTFOLIOS_OPTION
      : {
          id: ownTab?.id ?? clientId ?? null,
          name: ownTab?.title ?? 'Собственный портфель',
        };

  const id = parsed.id == null ? null : Number(parsed.id);
  const name = typeof parsed.name === 'string' ? parsed.name : null;

  if (id == null) {
    return allowAll ? ALL_PORTFOLIOS_OPTION : defaultOption;
  }

  if (!Number.isFinite(id) || id <= 0) {
    return defaultOption;
  }

  const tab = userTabs.find((t) => Number(t.id) === id);
  if (tab) {
    return { id, name: name || tab.title || '' };
  }

  return defaultOption;
};

/**
 * Портфель инвестиций из localStorage — объект { id, name }, как валюта.
 * @param {string} [storageKey]
 * @param {{ allowAll?: boolean, clientId?: number, userTabs?: Array<{id?: number, title?: string}> }} [options]
 */
export const getInvestPortfolio = (
  storageKey = LocalStorageHelper.INVEST_PORTFOLIO,
  { allowAll = false, clientId, userTabs = [] } = {}
) => {
  const ownTab = userTabs.find((tab) => Number(tab.id) === Number(clientId)) ?? userTabs[0] ?? null;
  const defaultOption =
    allowAll && userTabs.length > 1
      ? ALL_PORTFOLIOS_OPTION
      : {
          id: ownTab?.id ?? clientId ?? null,
          name: ownTab?.title ?? 'Собственный портфель',
        };

  if (typeof window === 'undefined') {
    return defaultOption;
  }

  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) {
      return defaultOption;
    }

    const parsed = JSON.parse(raw);
    return normalizeStoredPortfolio(parsed, { allowAll, clientId, userTabs }) ?? defaultOption;
  } catch (err) {
    console.warn('[getInvestPortfolio] Не удалось прочитать портфель:', err);
    return defaultOption;
  }
};

export const writeStoredInvestPortfolio = (
  portfolio,
  storageKey = LocalStorageHelper.INVEST_PORTFOLIO
) => {
  if (typeof window === 'undefined' || !portfolio) {
    return;
  }

  try {
    localStorage.setItem(
      storageKey,
      JSON.stringify({
        id: portfolio.id ?? null,
        name: portfolio.name ?? '',
      })
    );
  } catch (err) {
    console.warn('[writeStoredInvestPortfolio] Не удалось сохранить портфель:', err);
  }
};

/** @deprecated используйте getInvestPortfolio(...).id */
export const readStoredInvestPortfolioId = (storageKey) => getInvestPortfolio(storageKey).id;

/** @deprecated используйте writeStoredInvestPortfolio */
export const writeStoredInvestPortfolioId = (portfolioId, storageKey) => {
  writeStoredInvestPortfolio({ id: portfolioId ?? null, name: '' }, storageKey);
};

/** @deprecated */
export const resolveInvestPortfolioId = (options) =>
  getInvestPortfolio(options.storageKey, {
    allowAll: options.allowAll,
    clientId: options.clientId,
    userTabs: (options.userTabIds ?? []).map((id) => ({ id, title: '' })),
  }).id;
